import { FormControl, FormGroup } from '@angular/forms';
import { PaymentFeeType } from 'app/models/payment-fee-type.model';
import { LinkLookup } from '@mrm/core';
import { ConventionGenderEnum, ConventionLanguageEnum } from '../lookup-enums.model';
import { RegistrationContactInfo } from '../registration-contact-info.model';
import { IRegistration } from '../registration-interface.model';
import { LUISGenders, LUISLanguages } from '../luis-enum';
export class ConventionRegistrationExtension implements IRegistration {
  conventionEnglishName: string = null;
  conventionFrenchName: string = null;
  localOrgNumber: string = null;
  localOrgName: string = null;
  localOrgCity: string = null;
  credentialNumber: string = null;
  processedEntityCredentialDBID: number = null;
  isRegistered: boolean = false;
  isCancelled: boolean = false;
  isConventionAssistFund: boolean = false;
  paymentFeeTypes: PaymentFeeType[] = null;
  paymentBalance?: number = null;
  selected: boolean = false;
  get isAttended(): boolean {
    return this['attendedDT'] != null;
  }
  replacedConventionDBID: number = null;

  // To implement interface (event though ConventionRegistration will have these)...
  registrationApprovalStatusDBID: number;
  registrationContactInfoDBID: number;
  registrationContactInfo: RegistrationContactInfo;
  personDBID?: number;

  /**
  * Override the default validation controls to set
  * @param form
  */
  static overrideDefaultForm(form: FormGroup) {
    form.addControl('conventionEnglishName', new FormControl({ value: null }));
    form.addControl('conventionFrenchName', new FormControl({ value: null }));
    form.addControl('localOrgNumber', new FormControl({ value: null }));
    form.addControl('localOrgName', new FormControl({ value: null }));
    form.addControl('localOrgCity', new FormControl({ value: null }));
    form.addControl('credentialNumber', new FormControl({ value: null }));
    form.addControl('processedEntityCredentialDBID', new FormControl({ value: null }));
    form.addControl('isRegistered', new FormControl({ value: null }));
    form.addControl('processedEntityNumber', new FormControl({ value: null, disabled: form.disabled }));
    form.addControl('processedEntityName', new FormControl({ value: null, disabled: true }));
    form.addControl('alternateType', new FormControl({ value: 0, disabled: form.disabled }));
    form.addControl('selected', new FormControl({ value: false, disabled: form.disabled }));
    form.addControl('replacedConventionDBID', new FormControl({ value: null, disabled: form.disabled }));
    form.addControl('isSigned', new FormControl({ value: null, disabled: true }));
  }

  /**
 * Remove all validators on the controls
 * @param form
 */
  static removeValidators(form: FormGroup) {
    for (const control in form.controls) {
      form.controls[control].clearValidators();
    }
  }

  // Get LUI GenderDBID using Convention specific lookup.
  getLUIGenderDBID(genders: LinkLookup[]): number {
    const linkGenderDBID = this['linkGenderConventionDBID'];
    if (linkGenderDBID == null) {
      return LUISGenders.Unknown;
    } else {
      const id = genders.find(x => x.linkId == linkGenderDBID).id;
      if (id == ConventionGenderEnum.M || id == ConventionGenderEnum.MA) {
        return LUISGenders.Male;
      } else if (id == ConventionGenderEnum.F || id == ConventionGenderEnum.W) {
        return LUISGenders.Female;
      } else if (id == ConventionGenderEnum.G) {
        return LUISGenders.Transgender;
      } else {
        return LUISGenders.Unknown;
      }
    }
  }

  // Get LUI LanguageDBID using Convention specific lookup.
  getLUILanguageDBID(languages: LinkLookup[]): number {
    const linkLanguageDBID = this['linkLanguageConventionDBID'];
    if (linkLanguageDBID == null) {
      return LUISLanguages.BilingualEnglish;
    } else {
      const id = languages.find(x => x.linkId == linkLanguageDBID).id;
      if (id == ConventionLanguageEnum.BE) {
        return LUISLanguages.BilingualEnglish;
      } else if (id == ConventionLanguageEnum.FR) {
        return LUISLanguages.French;
      } else if (id == ConventionLanguageEnum.BF) {
        return LUISLanguages.BilingualFrench;
      } else {
        return LUISLanguages.English;
      }
    }
  }
}
